import { Head } from "@inertiajs/react"
import { Bell, BellOff } from "lucide-react"
import { useState } from "react"

import HeadingSmall from "@/components/heading-small"
import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import {
  isPushSupported,
  subscribeToPush,
  unsubscribeFromPush,
} from "@/lib/push-notifications"
import type { BreadcrumbItem } from "@/types"
import type { SettingsPushSubscriptionsShow } from "@/types/serializers"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Notificaciones push",
    href: "/configuracion/notificaciones-push",
  },
]

export default function PushSubscriptionShow({
  vapid_public_key,
  push_enabled,
}: SettingsPushSubscriptionsShow) {
  const [loading, setLoading] = useState(false)
  const supported = typeof window !== "undefined" ? isPushSupported() : true

  function handleEnable() {
    setLoading(true)
    void subscribeToPush(vapid_public_key).then(() => {
      setLoading(false)
    })
  }

  function handleDisable() {
    setLoading(true)
    void unsubscribeFromPush().then(() => {
      setLoading(false)
    })
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Notificaciones push" />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Notificaciones push"
            description="Recibí notificaciones en tu navegador cuando tengas nuevos mensajes, seguidores o actividad en tu perfil"
          />

          <div className="space-y-4">
            <div className="border-border flex items-center gap-3 rounded-lg border p-4">
              {push_enabled ? (
                <Bell className="text-krown-200 h-5 w-5" />
              ) : (
                <BellOff className="text-muted-foreground h-5 w-5" />
              )}
              <div className="flex-1">
                <p className="text-sm font-medium">
                  {push_enabled
                    ? "Notificaciones activadas"
                    : "Notificaciones desactivadas"}
                </p>
                <p className="text-muted-foreground text-xs">
                  {push_enabled
                    ? "Recibirás notificaciones en este navegador"
                    : "No recibirás notificaciones push en este navegador"}
                </p>
              </div>
            </div>

            {!supported && (
              <p className="text-muted-foreground text-sm">
                Tu navegador no soporta notificaciones push.
              </p>
            )}

            {push_enabled ? (
              <Button
                variant="outline"
                onClick={handleDisable}
                disabled={loading}
              >
                Desactivar notificaciones
              </Button>
            ) : (
              <Button onClick={handleEnable} disabled={loading || !supported}>
                Activar notificaciones
              </Button>
            )}
          </div>
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
